export default __webpack_public_path__ + "static/media/close.0b0b6f95.svg";